import { createSlice } from "@reduxjs/toolkit";

const defaultState = {
  isInitialized: false,
  lastPayDate: null,
  maxDate: null,
  minDate: null,
  participant: {},
  payTypes: [],
  providerTypes: [],
  providers: [],
};

const configurationSlice = createSlice({
  name: "configurationSlice",
  initialState: {
    ...defaultState,
    selectedPPTConfiguration: { ...defaultState },
  },
  reducers: {
    setConfiguration: (_, action) => action.payload,
    setSelectedPPTConfiguration: (state, action) => {
      state.selectedPPTConfiguration = action.payload;
    },
  },
});

export const { setConfiguration, setSelectedPPTConfiguration } = configurationSlice.actions;

export default configurationSlice.reducer;
